module.exports = "/images/placeholder.png?8b06235766fb3fdf06805f309912882e";